import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
//import Helmet from 'react-helmet';
//import Modal from 'react-modal';
//import { push } from 'react-router-redux';
import * as authActions from '../../redux/modules/auth';
import * as commonActions from './../../actions/commonActions';


const elementsData = [
  {"classNames":"accLabel", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"verHeading", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
];

@connect(
  state => ({
    userDetail:state.auth.userDetail,
    versionList:state.dashboardRoot.dashboardReducer.versionList,
    }),
    {...authActions, ...commonActions})

export default class Version extends Component {
  static propTypes = {
    //pushState: PropTypes.func,
  }

  state = {

  }

  constructor(props){
    super(props);

  }

  componentWillMount() {

  }

  componentDidMount() {

  }

  render() {

    return (
      <React.Fragment>
        <div>
          <div className="containerV">
            <div className="row">
              <div className="col-12">

                <div className="accordion">
                  {JSON.parse((this.props.versionList[0]).versiondata).map((item, index) => {
                    return (
                      <div className="accTab">
                        {item.version_number === this.props.userDetail.versionNo ?
                          <input type="radio" id={item.version_number} name="versions" className="accInput" defaultChecked />
                        :
                          <input type="radio" id={item.version_number} name="versions" className="accInput" />
                        }
                        <label htmlFor={item.version_number} className="accLabel">Version {item.version_number}<span className="date">({item.ReleaseDate})</span></label>

                        <div className="accContent">
                          {item.features.length > 0 ?
                            <React.Fragment>
                              <h4 className="verHeading">Features Added</h4>
                              <ul>
                                {item.features.map((feature)=>{
                                  return (
                                    <li>
                                      <p>{feature.description}</p>
                                      <p>{feature.comment}</p>
                                    </li>
                                  )
                                })}
                              </ul>
                            </React.Fragment>
                          : null}

                          {item.bugFixes.length > 0 ?
                            <React.Fragment>
                              <h4 className="verHeading">Bugs Fixed</h4>
                              <ul>
                                {item.bugFixes.map((bug)=>{
                                  return (
                                    <li>
                                      <p>{bug.description}</p>
                                      <p>{bug.comment}</p>
                                    </li>
                                  )
                                })}
                              </ul>
                            </React.Fragment>
                          : null}
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
